import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import compressImage from "../../blue-library/utils/compressImage";
import { jsonToContentTypedBlob, getUserToken, isMobileApp } from "../utils";
import request, { useSubmitTime } from "./request";
export function uploadCompetitorProof(_x, _x2) { return _uploadCompetitorProof.apply(this, arguments); }
function _uploadCompetitorProof() { _uploadCompetitorProof = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(param, proof) { var fd, reqData, result; return _regeneratorRuntime.wrap(function _callee$(_context) { while (1) {
    switch (_context.prev = _context.next) {
        case 0:
            fd = new FormData();
            reqData = Object.assign({ productCode: param.productCode, proofType: "LOWEST_RATE_PROOF", contactTitle: param.contactTitle, contactName: param.contactName, contactEmail: param.contactEmail, contactMobileCountryCode: param.contactMobileCountryCode, contactMobileNumber: param.contactMobileNumber, contactPeriodPreferred: param.contactPeriodPreferred, captchaCode: param.captchaCode, isMobileApp: isMobileApp() }, useSubmitTime());
            fd.set("files", proof);
            _context.t0 = fd;
            _context.next = 6;
            return jsonToContentTypedBlob(reqData);
        case 6:
            _context.t1 = _context.sent;
            _context.t0.set.call(_context.t0, "request", _context.t1);
            _context.next = 10;
            return request.post("/api/v1/online/online/uploadCompetitorProof", fd, { headers: { "X-Inline-Error": "true" } });
        case 10:
            result = _context.sent;
            return _context.abrupt("return", result.data);
        case 12:
        case "end": return _context.stop();
    }
} }, _callee); })); return _uploadCompetitorProof.apply(this, arguments); }
export function uploadProof(_x3, _x4, _x5, _x6) { return _uploadProof.apply(this, arguments); }
function _uploadProof() {
    _uploadProof = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(quotationNumber, hkidImage, relationship, childType) {
        var fd, reqData, compressedFile, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        fd = new FormData();
                        reqData = Object.assign({ insRelationApp: relationship !== null && relationship !== void 0 ? relationship : "00",
                            insuredFileType: childType == "cert" ? "7" : "01", quoteNo: quotationNumber, userToken: getUserToken(quotationNumber), isMobileApp: isMobileApp() }, useSubmitTime()); // SIS-1951 tencent api limit
                        _context2.next = 4;
                        return compressImage(hkidImage);
                    case 4:
                        compressedFile = _context2.sent;
                        fd.set("file", compressedFile);
                        _context2.t0 = fd;
                        _context2.next = 9;
                        return jsonToContentTypedBlob(reqData);
                    case 9:
                        _context2.t1 = _context2.sent;
                        _context2.t0.set.call(_context2.t0, "data", _context2.t1);
                        _context2.next = 13;
                        return request.post("/api/v1/ekyc/uploadProof", fd, { headers: { "X-Inline-Error": "true" } });
                    case 13:
                        result = _context2.sent;
                        if (result.data.result) {
                            _context2.next = 16;
                            break;
                        }
                        throw new Error("Err.");
                    case 16:
                    case "end": return _context2.stop();
                }
            }
        }, _callee2);
    }));
    return _uploadProof.apply(this, arguments);
}
export function faceVerification(_x7, _x8) { return _faceVerification.apply(this, arguments); } // export interface ApiCheckSummaryRequest {
//   quoteNo: string;
//   useSubmitTime: true;
// }
// type ApiCheckSummaryResult = boolean;
function _faceVerification() {
    _faceVerification = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3(quotationNumber, faceImage) {
        var fd, reqData, compressedFile, result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        fd = new FormData();
                        reqData = Object.assign({ quoteNo: quotationNumber, userToken: getUserToken(quotationNumber) }, useSubmitTime(), { isMobileApp: isMobileApp() }); // SIS-1951 tencent api limit
                        _context3.next = 4;
                        return compressImage(faceImage);
                    case 4:
                        compressedFile = _context3.sent;
                        fd.set("file", compressedFile);
                        _context3.t0 = fd;
                        _context3.next = 9;
                        return jsonToContentTypedBlob(reqData);
                    case 9:
                        _context3.t1 = _context3.sent;
                        _context3.t0.set.call(_context3.t0, "data", _context3.t1);
                        _context3.next = 13;
                        return request.post("/api/v1/ekyc/fr", fd, { headers: { "X-Inline-Error": "true" } });
                    case 13:
                        result = _context3.sent;
                        if (result.data.result) {
                            _context3.next = 16;
                            break;
                        }
                        throw new Error("Err.");
                    case 16:
                    case "end": return _context3.stop();
                }
            }
        }, _callee3);
    }));
    return _faceVerification.apply(this, arguments);
}
export function checkSummary(_x9, _x10) { return _checkSummary.apply(this, arguments); }
function _checkSummary() { _checkSummary = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee4(req, language) { var resp; return _regeneratorRuntime.wrap(function _callee4$(_context4) { while (1) {
    switch (_context4.prev = _context4.next) {
        case 0:
            _context4.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/checkSummaryInfo/" + req.productCode, Object.assign({}, req, { useSubmitTime: true, productCode: undefined }), { headers: { "Accept-Language": language === "hk" ? "zh-HK" : language === "cn" ? "zh-CN" : "en-US" } });
        case 2:
            resp = _context4.sent;
            return _context4.abrupt("return", resp.data);
        case 4:
        case "end": return _context4.stop();
    }
} }, _callee4); })); return _checkSummary.apply(this, arguments); }
export function viewImage(_x11, _x12) { return _viewImage.apply(this, arguments); }
function _viewImage() { _viewImage = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee5(quoteNo, partyFlag) { return _regeneratorRuntime.wrap(function _callee5$(_context5) { while (1) {
    switch (_context5.prev = _context5.next) {
        case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return fetch("/api/v1/ekyc/viewImage", { method: "post", headers: { "Content-Type": "application/json" }, body: JSON.stringify(Object.assign({ quoteNo: quoteNo, partyFlag: partyFlag, isMobileApp: isMobileApp(), userToken: getUserToken(quoteNo) }, useSubmitTime())) }).then(function (v) { return v.blob(); }).then(function (blob) { var reader = new FileReader(); var promise = new Promise(function (resolve) { reader.onload = function (event) { var _event$target; resolve(event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.result); }; }); reader.readAsDataURL(blob); return promise; }).then(function (p) { return p; });
        case 3: return _context5.abrupt("return", _context5.sent);
        case 6:
            _context5.prev = 6;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", "");
        case 9:
        case "end": return _context5.stop();
    }
} }, _callee5, null, [[0, 6]]); })); return _viewImage.apply(this, arguments); }
export function deleteProofInResult(_x13) { return _deleteProofInResult.apply(this, arguments); }
function _deleteProofInResult() { _deleteProofInResult = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee6(req) { var resp; return _regeneratorRuntime.wrap(function _callee6$(_context6) { while (1) {
    switch (_context6.prev = _context6.next) {
        case 0:
            _context6.next = 2;
            return request.post("/api/v1/ekyc/deleteProofInResult", req);
        case 2:
            resp = _context6.sent;
            return _context6.abrupt("return", resp.data);
        case 4:
        case "end": return _context6.stop();
    }
} }, _callee6); })); return _deleteProofInResult.apply(this, arguments); }
export function requestEkyc(_x14) { return _requestEkyc.apply(this, arguments); }
function _requestEkyc() { _requestEkyc = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee7(req) { var resp; return _regeneratorRuntime.wrap(function _callee7$(_context7) { while (1) {
    switch (_context7.prev = _context7.next) {
        case 0:
            _context7.next = 2;
            return request.post("/api/v1/quotation/quoteMain/saveQuoteInfo/requestEkyc/" + req.productCode, Object.assign({}, req, { productCode: undefined, useSubmitTime: true }));
        case 2:
            resp = _context7.sent;
            return _context7.abrupt("return", resp.data);
        case 4:
        case "end": return _context7.stop();
    }
} }, _callee7); })); return _requestEkyc.apply(this, arguments); }
